import React, { createContext, useEffect, useState, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import delay from 'delay'
import hipersendService from '../../services/hipersend'

const ApiDataWrapperContext = createContext()

const ApiDataWrapperProvider = ({ children }) => {
  const [queryParameters] = useSearchParams()
  const [server, setServer] = useState('')
  const [isSuspended, setIsSuspended] = useState(undefined)
  const [isDisabled, setIsDisabled] = useState(false)
  const [provider, setProvider] = useState('')
  const [phone, setPhone] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [whatsappBusinessId, setWhatsappBusinessId] = useState('')
  const [whatsappBusinessNumberId, setWhatsappBusinessNumberId] = useState('')
  const [whatsappBusinessToken, setWhatsappBusinessToken] = useState('')
  const [statusSession, setStatusSession] = useState('')
  const [user, setUser] = useState(undefined)
  const [verifiedName, setVerifiedName] = useState('')
  // Flag por instância (definida pelo operador): controla se o "saldo estimado"
  // aparece pro cliente. Só faz sentido pra quem usa a nossa linha de crédito.
  const [usaLinhaDeCredito, setUsaLinhaDeCredito] = useState(false)
  // Saldo pré-pago REAL vindo do backend: { consumoMsgs, gasto, recargas, saldo } ou
  // null (não-cobrável). precoMsgPacote = preço/msg do pacote contratado (ou null).
  const [saldoInfo, setSaldoInfo] = useState(null)
  const [precoMsgPacote, setPrecoMsgPacote] = useState(null)

  const getCredentials = () => {
    const api = queryParameters.get('api') || window.localStorage.getItem('api')
    const secret = queryParameters.get('secret') || window.localStorage.getItem('secret')

    return { api, secret }
  }

  const fetchData = async () => {
    try {

      const { api, secret } = getCredentials()
      if(!api || !secret) {
        return
      }
      if(phone && server && isSuspended) {
        return
      }

      setIsLoading(true)
      await delay(1000)

      const response = await hipersendService.notificacoesInteligentes.getInformations(api, secret)

      setServer(response.numberServer)
      setIsSuspended(response.isSuspended)
      setIsDisabled(response.isDisabled)

      const isMetaProvider = response.provider === 'hiperapi-v3-cloud-official'
      const metaDisplayPhone = response.whatsappCloudApiDisplayPhone
      const resolvedPhone = isMetaProvider && metaDisplayPhone
        ? metaDisplayPhone.replace(/^\+/, '').replace(/\D/g, '')
        : response.info.me.user
      setPhone(resolvedPhone)

      setProvider(response.provider)
      setWhatsappBusinessId(response.whatsappCloudApiBusinessId)
      setWhatsappBusinessNumberId(response.whatsappCloudApiNumberId)
      setWhatsappBusinessToken(response.whatsappCloudApiToken)
      setStatusSession(response.statusSession)
      setUser(response.user)
      setUsaLinhaDeCredito(!!response.usaLinhaDeCredito)
      setSaldoInfo(response.saldo || null)
      setPrecoMsgPacote((response.cobranca && response.cobranca.precoMsg) || null)
      setVerifiedName(response.whatsappCloudApiVerifiedName || '')
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  // Re-busca SÓ o saldo (sem refazer o boot inteiro nem o delay), pra atualizar
  // depois de envios/recargas quando o cliente clica "Atualizar" ou troca de aba —
  // o saldo muda com o consumo. Falha aqui não atrapalha o resto do painel.
  const refreshSaldo = useCallback(async () => {
    try {
      const api = queryParameters.get('api') || window.localStorage.getItem('api')
      const secret = queryParameters.get('secret') || window.localStorage.getItem('secret')
      if (!api || !secret) return
      const response = await hipersendService.notificacoesInteligentes.getInformations(api, secret)
      setSaldoInfo(response.saldo || null)
      setPrecoMsgPacote((response.cobranca && response.cobranca.precoMsg) || null)
    } catch (error) {
      console.error(error)
    }
  }, [queryParameters])

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <ApiDataWrapperContext.Provider
      value={{
        getCredentials,
        isSuspended,
        setIsSuspended,
        isDisabled,
        setIsDisabled,
        server,
        setServer,
        phone,
        setPhone,
        provider,
        setProvider,
        fetchData,
        isLoading,
        setIsLoading,
        whatsappBusinessId,
        setWhatsappBusinessId,
        whatsappBusinessNumberId,
        setWhatsappBusinessNumberId,
        whatsappBusinessToken,
        setWhatsappBusinessToken,
        setStatusSession,
        statusSession,
        setUser,
        user,
        usaLinhaDeCredito,
        saldoInfo,
        precoMsgPacote,
        refreshSaldo,
        verifiedName,
        setVerifiedName
      }}
    >
      {children}
    </ApiDataWrapperContext.Provider>
  )
}

export {
  ApiDataWrapperContext,
  ApiDataWrapperProvider
}
